import React, { useEffect, useState } from 'react';
import { useNavigate, Route, Routes, useLocation } from 'react-router-dom';
import './index.css';
import { Layout, Menu, Image, Space, Typography, Select } from 'antd';
import {
  Dashboard,
  BoxManagement,
  BoxManagementGo,
  ServerPortal,
  TransactionReport,
  VendorUser,
  MasterPortal,
  OtaUpdate,
} from '../';
import { UserProfile } from '../../components/Header';
import { ChangePassword } from '../../components';
import { actionsApi } from '../../shared';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;
const { Option } = Select;

const SideBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const [collapsed, setCollapsed] = useState(false);
  const [items, setItems] = useState([]);
  const [currentTab, setCurrentTab] = useState('1');
  const [userData, setUserData] = useState(null);
  const [openKeys, setOpenKeys] = useState(['sub1']);

  const storedUser = localStorage.getItem('user');
  const role = storedUser ? JSON.parse(storedUser).role : null;

  useEffect(() => {
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUserData(parsedUser);
      dispatch(actionsApi?.loginResponse(parsedUser));
    }
  }, [dispatch, storedUser]);

  function getItem(label, key, icon, children, disabled = false) {
    return { key, icon, children, label, disabled };
  }

  useEffect(() => {
    let tab = location?.pathname?.split('/')[1];
    tab = tab === 'Dashboard'
      ? '1'
      : tab === 'box-management-my-enjoy-tv'
      ? '2'
      : tab === 'box-management-iptv-go'
      ? '3'
      : tab === 'ota-update'
      ? '9'
      : tab === 'vendoruser'
      ? '4'
      : tab === 'serverportal'
      ? '5'
      : tab === 'master-portal'
      ? '6'
      : tab === 'transactionreport'
      ? '7'
      : tab === 'evreka'
      ? '8'
      : '1';
    setCurrentTab(tab);
  }, [location]);

  useEffect(() => {
    if (role) {
      let boxManagementSubMenu =
        role === 'masterAdmin'
          ? [
              getItem(<Text className="text-white">{t("MY ENJOY TV")}</Text>, '2'),
              getItem(<Text className="text-white">{t("GO IPTV")}</Text>, '3'),
            ]
          : [getItem(<Text className="text-white">{t("MY ENJOY TV")}</Text>, '2')];

      let itemsArr =
        role === 'masterAdmin'
          ? [
              getItem(
                <Text className="text-white">{t("Dashboard")}</Text>,
                '1',
                <img
                  src="/assets/icons/dashboard.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />
              ),
              getItem(
                <Text className="text-white">{t("Box Management")}</Text>,
                'sub1',
                <img
                  src="/assets/icons/category.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />,
                [...boxManagementSubMenu]
              ),
              getItem(
                <Text className="text-white">{t("OTA Update")}</Text>,
                '9',
                <img
                  src="/assets/icons/upload.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />
              ),
              getItem(
                <Text className="text-white">{t("Master Vendors")}</Text>,
                '4',
                <img
                  src="/assets/icons/vendoruser.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />
              ),
              getItem(
                <Text className="text-white">{t("Server Portal")}</Text>,
                '5',
                <img
                  src="/assets/icons/serverportal.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />,
                null,
                true // Disabled here
              ),
              getItem(
                <Text className="text-white">{t("Master Portal")}</Text>,
                '6',
                <img
                  src="/assets/icons/masterportal.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />
              ),
              getItem(
                <Text className="text-white">{t("Transaction Report")}</Text>,
                '7',
                <img
                  src="/assets/icons/transactionrep.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />,
                null,
                true // Disabled here
              ),
              getItem(
                <Text className="text-white">{t("Evreka")}</Text>,
                '8',
                <img
                  src="/assets/icons/evreka.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />,
                null,
                false
              ),
            ]
          : [
              getItem(
                <Text className="text-white">{t("Dashboard")}</Text>,
                '1',
                <img
                  src="/assets/icons/dashboard.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />
              ),
              getItem(
                <Text className="text-white">{t("Box Management")}</Text>,
                'sub1',
                <img
                  src="/assets/icons/category.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />,
                [...boxManagementSubMenu]
              ),
              getItem(
                <Text className="text-white">{t("Server Portal")}</Text>,
                '5',
                <img
                  src="/assets/icons/serverportal.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />,
                null,
                true // Disabled here
              ),
              getItem(
                <Text className="text-white">{t("Master Portal")}</Text>,
                '6',
                <img
                  src="/assets/icons/masterportal.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />
              ),
              getItem(
                <Text className="text-white">{t("Transaction Report")}</Text>,
                '7',
                <img
                  src="/assets/icons/transactionrep.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />,
                null,
                true // Disabled here
              ),
              getItem(
                <Text className="text-white">{t("Evreka")}</Text>,
                '8',
                <img
                  src="/assets/icons/evreka.png"
                  width={'18px'}
                  alt=""
                  style={{ verticalAlign: 'middle' }}
                />,
                null,
                false
              ),
            ];

      setItems([...itemsArr]);
    }
  }, [role, t]);

  const handleMenuClick = (e) => {
    const { key } = e;

    if (key === '8') {
      // Evreka öğesine tıklanınca yeni sekmede site açılır
      window.open('https://evreka.controlyourbox.com/', '_blank');
      return;
    }

    switch (key) {
      case '1':
        navigate('/', { replace: true });
        break;
      case '2':
        navigate('/box-management-my-enjoy-tv', { replace: true });
        break;
      case '3':
        navigate('/box-management-iptv-go', { replace: true });
        break;
      case '4':
        navigate('/vendoruser', { replace: true });
        break;
      case '9':
        navigate('/ota-update', { replace: true });
        break;
      case '5':
        navigate('/serverportal', { replace: true });
        break;
      case '6':
        navigate('/master-portal', { replace: true });
        break;
      case '7':
        navigate('/transactionreport', { replace: true });
        break;
      default:
        break;
    }
  };

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  // Dil değiştirici fonksiyon
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
  };

  return (
    <Layout style={{ height: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{ height: '100vh', overflowY: 'auto' }}
      >
        <div className="logo" style={{ display: 'flex', justifyContent: 'center' }}>
          <Image
            style={{ width: collapsed ? '100%' : '100px' }}
            height={'auto'}
            src="./assets/logo-w.png"
            alt="Store App Admin Panel"
            preview={false}
          />
        </div>
        <Menu
          defaultSelectedKeys={['1']}
          selectedKeys={[currentTab]}
          mode="inline"
          theme="dark"
          onClick={handleMenuClick}
          onOpenChange={onOpenChange}
          openKeys={openKeys}
          items={items}
          className="listitem"
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="site-layout-background"
          style={{
            padding: 0,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              width: '95%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <div className="trigger border-0-btn" onClick={() => setCollapsed(!collapsed)}>
              <Image src="/assets/icons/collaps.png" width={'35.46px'} preview={false} />
            </div>
            <Space size={20} align="center" style={{display: 'flex', alignItems: 'center'}}>
              {/* Dil Seçici */}
              <Select
                value={i18n.language}
                onChange={changeLanguage}
                style={{ width: 120 }}
                popupMatchSelectWidth={false}
                optionLabelProp="label"
              >
                <Option
                  value="en"
                  label={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img src="/assets/icons/uk.png" alt="English" style={{ width: 20, marginRight: 8 }} />
                      English
                    </div>
                  }
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src="/assets/icons/uk.png" alt="English" style={{ width: 20, marginRight: 8 }} />
                    English
                  </div>
                </Option>
                <Option
                  value="tr"
                  label={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img src="/assets/icons/tr.png" alt="Turkish" style={{ width: 20, marginRight: 8 }} />
                      Türkçe
                    </div>
                  }
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src="/assets/icons/tr.png" alt="Turkish" style={{ width: 20, marginRight: 8 }} />
                    Türkçe
                  </div>
                </Option>
              </Select>

              <UserProfile role={userData ? userData.role : ''} />
            </Space>
          </div>
        </Header>

        <Content
          className="scroll-bar"
          style={{
            margin: '24px 16px',
            padding: 0,
            minHeight: 280,
            overflowY: 'auto',
          }}
        >
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/box-management-my-enjoy-tv" element={<BoxManagement />} />
            {role === 'masterAdmin' && (
              <>
                <Route path="/box-management-iptv-go" element={<BoxManagementGo />} />
                <Route path="/vendoruser" element={<VendorUser />} />
                <Route path="/ota-update" element={<OtaUpdate />} />
              </>
            )}
            <Route path="/master-portal" element={<MasterPortal />} />
            <Route path="/serverportal" element={<ServerPortal />} />
            <Route path="/masterportal" element={<Dashboard />} />
            <Route path="/transactionreport" element={<TransactionReport />} />
            <Route path="/changepassword" element={<ChangePassword />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default SideBar;
